import React, { createContext, useCallback, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { schema } from '../validations';
import { useForm } from 'react-hook-form';
import { FormType, rowProps } from '../types';
import {
  ProvideralteracaoIbsCbsLoteContextProps,
  alteracaoIbsCbsLoteContextData,
} from '../types/context';
import { toast } from 'react-toastify';
import api from '~/services/api';

export const alteracaoIbsCbsLoteContext = createContext(
  {} as alteracaoIbsCbsLoteContextData,
);

export const AlteracaoIbsCbsLoteProvider: React.FC<
  ProvideralteracaoIbsCbsLoteContextProps
> = ({ children }) => {
  const [lojas, setLojas] = useState<number | number[]>([1]);
  const [loadingTable, setLoadingTable] = useState<boolean>(false);
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const [flgSemIbsCbs, setFlgSemIbsCbs] = useState<boolean>(false);
  const [resetCampo, setResetCampo] = useState<boolean>(false);
  const [rows, setRows] = useState<rowProps[]>([]);

  const {
    register,
    getValues,
    handleSubmit,
    formState,
    control,
    setValue,
    watch,
    reset,
    setFocus,
    clearErrors,
    setError,
  } = useForm({
    resolver: yupResolver(schema),
    reValidateMode: 'onBlur',
  });
  const formAlteracaoIbsCbs: FormType = {
    register,
    getValues,
    handleSubmit,
    formState,
    control,
    setValue,
    watch,
    reset,
    setFocus,
    clearErrors,
    setError,
  };

  const handleChangeLojas = useCallback((value: number | number[]) => {
    setLojas(value);
  }, []);

  const handleCheckProduct = (uuid: string) => {
    setRows((prev) =>
      prev.map((produto) =>
        produto.uuid === uuid
          ? { ...produto, flg_transfer: !produto.flg_transfer }
          : produto,
      ),
    );
  };

  const handleCheckAllProducts = async (check: boolean) => {
    const newRowsProduto = rows.map((produto) => {
      produto.flg_transfer = check;
      return produto;
    });
    setRows(newRowsProduto || []);
  };

  const onTransfer = handleSubmit(async (data) => {
    setLoadingSubmit(true);
    const existTransfer = rows.some((item) => item.flg_transfer === true);
    if (!existTransfer) {
      setLoadingSubmit(false);
      return toast.warn(
        'Ao menos um produto deve ter sido marcado para transferir',
      );
    }
    try {
      const produtosForUpdate = rows
        .filter((i) => i.flg_transfer === true)
        .map((produto) => {
          return {
            cod_loja: produto.cod_loja,
            cod_produto: produto.cod_produto,
            cod_ibs_cbs: data.cod_ibs_cbs.value,
          };
        });

      const res = await api.put('/alteracao-ibs-cbs-em-lote', {
        produtosForUpdate,
      });
      const { success, message } = res.data;

      if (success) {
        toast.success(message);
        resetFormData();
        setLoadingSubmit(false);
      }
    } catch (error) {
      setLoadingSubmit(false);
    }
  });

  const resetFormData = useCallback(() => {
    reset({
      busca_produto: [{ label: undefined, value: undefined }],
      cod_ibs_cbs: { label: undefined, value: undefined },
    });
    setRows([]);
    setFlgSemIbsCbs(false);
    setResetCampo(true);
  }, [reset]);

  return (
    <alteracaoIbsCbsLoteContext.Provider
      value={{
        formAlteracaoIbsCbs,
        onTransfer,
        resetFormData,
        loadingTable,
        setLoadingTable,
        loadingSubmit,
        setLoadingSubmit,
        flgSemIbsCbs,
        setFlgSemIbsCbs,
        resetCampo,
        setResetCampo,
        lojas,
        handleChangeLojas,
        handleCheckProduct,
        handleCheckAllProducts,
        rows,
        setRows,
      }}
    >
      {children}
    </alteracaoIbsCbsLoteContext.Provider>
  );
};
